// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "vendors") return "vendors.css";
	// return url for filenames based on template
	return undefined;
};